export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13488.d8d60b1e.jpg";